export default {
      id: "icon--calendar-small-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--calendar-small-usage",
      toString: function () {
        return this.url;
      }
    }